<template>
  <ListGuides />
</template>

<script>
import ListGuides from '@/components/guides/List';

export default {
  name: 'GuidesIndex',

  components: {
    ListGuides
  }
};
</script>
